import React, { Suspense } from "react";
import "./App.css";
import Spinner from "./components/common/Spinner";
import { Route, Routes } from "react-router-dom";
import routes from "./router";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";
import { NotFound } from "./components/common/NotFound";
import Notice from "./components/notice";

import { HelmetProvider } from "react-helmet-async";
import "./firebase_group";
import "./firebase_motel";
import FirebaseViewStay15s from "./firebase/viewpage/viewStay15s";
import FirebaseViewIntro from "./firebase/viewpage/viewIntro";
import FirebaseViewDev from "./firebase/viewpage/viewDev";

// import 'rsuite/dist/rsuite-no-reset.min.css';
import "rsuite/styles/index.less";
import FirebaseViewPrivacy from "./firebase/viewpage/viewPrivacy";

import { ChatContextProvider } from "./context/chat-context";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Suspense
          fallback={
            <div className="w-screen h-screen">
              <Spinner />
            </div>
          }
        >
          <ChatContextProvider>
            <div className="App">
              <FirebaseViewStay15s />
              <FirebaseViewIntro />
              <FirebaseViewPrivacy />
              <FirebaseViewDev />
              <Notice />
              <Routes>
                {routes.map((route, index) => {
                  // console.log(route);
                  return (
                    <Route
                      element={
                        <>
                          <ScrollToTop
                            className="hidden sm:block"
                            component={
                              <img
                                alt="Arrow upward alt"
                                className=""
                                src="/assets/images/scrollup.svg"
                              />
                            }
                            smooth
                            style={{
                              backgroundColor: "unset",
                              borderRadius: "100%",
                              right: 20,
                              bottom: 84,
                              width: 48,
                              height: 48,
                              boxShadow: "unset",
                              zIndex: 20,
                            }}
                          />
                          <route.component />
                        </>
                      }
                      key={index}
                      path={route.path}
                    />
                  );
                })}
                <Route element={<NotFound />} path="*" />
              </Routes>
            </div>
          </ChatContextProvider>
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
